import { PermissionType } from './security/permission.interfaces';

export const PII_ACCESS = {
  id: 406,
  type: PermissionType.BOOLEAN
};
